export default __webpack_public_path__ + "static/logo-getindata-xebia-da77101493f88b75df73ed36cfdd8257.svg";